import ExtremeMapAbstractLayerManager from '@/lib/ExtremeMapAbstractLayerManager';
import { JMATileLayer } from '@/lib/jma_layer/JMATileLayer';
import TileLayer from 'ol/layer/Tile';
import { TargetTime } from './jma_layer';

export default class ExtremeMapWeatherRadarLayerManager extends ExtremeMapAbstractLayerManager {
  jmaLayer: JMATileLayer | null;
  radarTimePoints: TargetTime[] | null;

  constructor() {
    super();
    this.jmaLayer = null;
    this.radarTimePoints = null;
  }

  async initializeLayer(layer: TileLayer, minuteOffsets: number[]): Promise<void> {
    if (!layer || !(layer instanceof JMATileLayer)) {
      throw new Error('Layer must be JMATileLayer instance');
    }

    this.jmaLayer = layer;
    this.radarTimePoints = await this.jmaLayer.getRadarTimePoints(minuteOffsets);
  }

  setRadarTimePoints(index: number): void {
    if (!this.jmaLayer || !this.radarTimePoints || index >= this.radarTimePoints.length) return;

    const targetTime = this.radarTimePoints[index];
    this.jmaLayer.setTargetTime(targetTime);
  }

  getLayerName(): string | null {
    return this.jmaLayer?.name ?? null;
  }

  destroy(): void {
    this.jmaLayer = null;
    this.radarTimePoints = null;
  }
}
